import i18n from 'infrastructure/i18n';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

import Sla from './sla';
import RpmStatus from './rpm-status';
import CcmStatus from './ccm-status';
import PatientName from './name';
import OutcomeCol from './outcome';
import s from './styles.module.scss';

import type { TableProps } from 'antd';
import type { ISmsCampaignAnswer } from 'infrastructure/interfaces';

interface IProps {
  onOpen: (rec: ISmsCampaignAnswer) => void;
}

export const useColumns = ({
  onOpen,
}: IProps): TableProps<ISmsCampaignAnswer>['columns'] => [
  {
    title: i18n.t('labels.sla'),
    key: 'serviceDeliveryThresholds',
    width: '20px',
    align: 'center',
    render: (_, rec) => <Sla value={rec.serviceDeliveryThresholds} />,
  },
  {
    title: i18n.t('labels.patientName'),
    key: 'patientName',
    render: (_, rec) => <PatientName data={rec} />,
  },
  {
    title: i18n.t('labels.dateOfBirth'),
    key: 'dateOfBirth',
    width: '130px',
    align: 'center',
    render: (_, rec) =>
      DateFormatter({
        date: rec.birthDate,
        format: DateFormats['MM-dd-yyyy'],
      }),
  },
  {
    title: i18n.t('labels.rpmStatus'),
    key: 'status',
    width: '270px',
    render: (_, rec) => <RpmStatus status={rec.status} />,
  },
  {
    title: i18n.t('labels.ccmStatus'),
    key: 'ccmStatus',
    width: '270px',
    render: (_, rec) => <CcmStatus ccmStatus={rec.ccmStatus} />,
  },
  {
    title: i18n.t('labels.outcome'),
    key: 'outcome',
    width: '100px',
    align: 'center',
    render: (_, rec) => <OutcomeCol onOpen={() => onOpen(rec)} />,
  },
  {
    title: i18n.t('labels.preferredEmailForEducationMaterials'),
    key: 'preferredEmailForEducationMaterials',
    width: '240px',
    render: (_, rec) => <span className={s.name}>{rec.email}</span>,
  },
];
